import { Seat } from "./seat.model";

export class SegmentChoice {
  private _segmentCode: string;
  private _seat: Seat;
  private _seatSelectionFee: string;


  constructor(value:{segmentCode?:string, seat?:any, seatSelectionFee?:any,segmentChoice:any}){
    const {segmentCode, seat, seatSelectionFee,segmentChoice } = value;

    if (segmentChoice) {
      this.segmentChoiceFromApi(segmentChoice);
    }
    else {
      this.createSegmentChoice(segmentCode, seat,seatSelectionFee)
    }

  }

  get segmentCode(): string {
    return this._segmentCode;
  }

  set segmentCode(segmentCode: string) {
    this._segmentCode = segmentCode;
  }

  get seat(): Seat {
    return this._seat;
  }

  set seat(seat: Seat) {
    this._seat = seat;
  }

  get seatSelectionFee(): string {
    return this._seatSelectionFee;
  }

  set seatSelectionFee(seatSelectionFee: string) {
    this._seatSelectionFee = seatSelectionFee;
  }

  clearSeat() {
    this._seat.clearSeat();
  }

  getSeatBalance() {
    if (this._seat != null) {
      return this._seat.getSeatBalance();
    }
    return 0;
  }

  createSegmentChoice(segmentCode, seat, seatSelectionFee) {
    this._segmentCode = segmentCode;
    this._seat = seat;
    this._seatSelectionFee = seatSelectionFee;
  }

  segmentChoiceFromApi(segmentChoice){
    const seat = new Seat({segmentChoice});
    this.createSegmentChoice(segmentChoice.segmentCode, seat, segmentChoice.seatSelectionFee)
  }

}
